import { Grid } from '@mui/material'
import { IInvoice } from 'models/invoices.models'
import {
  formatCatalogueLabel,
  getFormattedCurrency,
  getFormattedDate,
} from 'lib/helpers/shared.helpers'
import { IAddPaymentComplementContainerProps } from 'containers/Invoices/PaymentComplements/AddPaymentComplementContainer/AddPaymentComplementContainer'
import Form from 'components/FormComponents/IOComponents/IOCustomForm/IOCustomForm'
import { DropdownCard } from 'components/FormComponents/Dropdown/Dropdown'
import TextField from 'components/FormComponents/IOComponents/TextField/TextField'

interface IPaymentComplementCFDIInfoProps
  extends Pick<IAddPaymentComplementContainerProps, 'version'> {
  invoice: IInvoice | null
}

const PaymentComplementCFDIInfo = ({
  invoice,
  version,
}: IPaymentComplementCFDIInfoProps) => {
  return (
    <DropdownCard
      id="invoiceDropdown"
      title="Factura Original"
      headerBackgroundColor="secondary"
      capitalize
      iconAlign="left"
      defaultExpanded
      elevation={3}>
      <Form onSubmit={() => true} onValidity={() => true}>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <TextField
              name="fecha"
              label="Fecha"
              value={getFormattedDate(invoice?.createdAt, 'short', '')}
              InputProps={{ disableUnderline: true }}
              inputProps={{ readOnly: true }}
              fullWidth
              exclude
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              name="uuid"
              label="UUID"
              value={invoice?.uuid}
              InputProps={{ disableUnderline: true }}
              inputProps={{ readOnly: true }}
              fullWidth
              exclude
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              name="serie"
              label="Serie"
              value={invoice?.serie}
              InputProps={{ disableUnderline: true }}
              inputProps={{ readOnly: true }}
              fullWidth
              exclude
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              name="folio"
              label="Folio"
              value={invoice?.folio}
              InputProps={{ disableUnderline: true }}
              inputProps={{ readOnly: true }}
              fullWidth
              exclude
            />
          </Grid>
          {version === '3.3' && (
            <Grid item xs>
              <TextField
                name="razonSocial"
                label="Razón social"
                value={invoice?.emisor?.name}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
          )}
          <Grid item xs={2}>
            <TextField
              name="moneda"
              label="Moneda"
              value={formatCatalogueLabel(invoice?.currency)}
              InputProps={{ disableUnderline: true }}
              inputProps={{ readOnly: true }}
              fullWidth
              exclude
            />
          </Grid>
          {version === '3.3' && (
            <Grid item xs>
              <TextField
                name="total"
                label="Total"
                value={getFormattedCurrency(invoice?.total)}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
          )}
        </Grid>
        {version === '4.0' && (
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <TextField
                name="clientRfc"
                label="RFC Receptor"
                value={invoice?.clients?.rfc}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                name="clientName"
                label="Receptor"
                value={invoice?.clients?.name}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                name="emisorRfc"
                label="RFC Receptor"
                value={invoice?.emisor?.rfc}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                name="emisorName"
                label="Receptor"
                value={invoice?.emisor?.name}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                name="subtotal"
                label="Subtotal"
                value={getFormattedCurrency(invoice?.subtotal)}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                name="total"
                label="Total"
                value={getFormattedCurrency(invoice?.total)}
                InputProps={{ disableUnderline: true }}
                inputProps={{ readOnly: true }}
                fullWidth
                exclude
              />
            </Grid>
          </Grid>
        )}
      </Form>
    </DropdownCard>
  )
}

export default PaymentComplementCFDIInfo
